<template>
    <rkm-form
        ref="Form"
        v-if="model"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Cadastro"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input-autocomplete
                                :repository="repositories.usuario"
                                :requestQueryStringParams="autocompleteRequestParams.usuario"
                                :searchFields="fields.autocomplete.usuario"
                                :validations="validations.usuario"
                                text-field="cidadaoNome"
                                label="Profissional"
                                placeholder="Digite o nome ou número do conselho profissional"
                                v-model="model.profissional"
                                uppercase
                            />
                        </rkm-col>
                        <rkm-col cols="6">
                            <rkm-form-select
                                label="Unidade"
                                textField="nomeFantasia"
                                valueField="id"
                                v-model="model.unidade"
                                :options="form.unidades"
                                :validations="validations.unidade"
                                show-default-option
                            />
                        </rkm-col>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="form.infraestruturas"
                                label="Local de atendimento"
                                show-default-option
                                text-field="nome"
                                v-model="model.infraestrutura"
                                :validations="validations.infraestrutura"
                                default-option-text="Selecione"
                                value-field="id"
                            />
                        </rkm-col>
                        <rkm-col>
                            <rkm-form-select
                                label="Equipe"
                                textField="descricao"
                                valueField="id"
                                v-model="model.equipe"
                                :options="form.equipes"
                                :validations="validations.equipe"
                                show-default-option
                            />
                        </rkm-col>
                    </rkm-row>
                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-select
                                label="CBO"
                                textField="codigoNome"
                                valueField="id"
                                v-model="model.cbo"
                                :options="form.cbos"
                                :validations="validations.cbo"
                                show-default-option
                            />
                        </rkm-col>
                        <rkm-col cols="4">
                            <rkm-form-date-picker
                                label="Data"
                                :validations="validations.data"
                                v-model="model.dataAtendimento"
                            />
                        </rkm-col>
                        <rkm-col>
                            <rkm-form-select
                                label="Turno"
                                v-model="model.turno"
                                show-default-option
                                :options="form.turnos"
                                :validations="validations.turno"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
                <rkm-area
                    title="Paciente"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="5">
                            <rkm-form-input
                                label="Nome (Nome social)"
                                :value="form.informacoesPaciente.nome"
                                :readonly="true"
                            />
                        </rkm-col>
                        <rkm-col cols="3">
                            <rkm-form-input
                                label="CNS"
                                :value="form.informacoesPaciente.cns"
                                :readonly="true"
                            />
                        </rkm-col>
                        <rkm-col cols="4">
                            <rkm-form-input
                                label="Data de nascimento"
                                :value="form.informacoesPaciente.dataNascimento"
                                :readonly="true"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
                <rkm-area
                    title="Exames"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-date-picker
                                label="Teste do Olhinho"
                                v-model="model.data.testeOlhinho"
                                :min-date="others.moment(model.dataAtendimento).subtract(20, 'years').format('DD/MM/YYYY')"
                                :max-date="others.moment(model.dataAtendimento).format('DD/MM/YYYY')"
                            />
                        </rkm-col>
                        <rkm-col cols="3">
                            <rkm-form-select
                                label="Resultado - Teste do Olhinho"
                                :options="form.exames.testeOlhinho"
                                :disabled="!model.data.testeOlhinho"
                                :validations="validations.resultado.testeOlhinho"
                                v-model="model.resultado.testeOlhinho"
                                show-default-option
                            />
                            </rkm-col>
                        <rkm-col cols="3">
                            <rkm-form-date-picker
                                label="Fundo de olho"
                                v-model="model.data.fundoOlho"
                                :min-date="others.moment(model.dataAtendimento).subtract(20, 'years').format('DD/MM/YYYY')"
                                :max-date="others.moment(model.dataAtendimento).format('DD/MM/YYYY')"
                            />
                        </rkm-col>
                        <rkm-col>
                            <rkm-form-select
                                label="Resultado - Fundo de olho"
                                :options="form.exames.fundoOlho"
                                :disabled="!model.data.fundoOlho"
                                :validations="validations.resultado.fundoOlho"
                                v-model="model.resultado.fundoOlho"
                                show-default-option
                            />
                        </rkm-col>
                    </rkm-row>
                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-date-picker
                                label="Teste da Orelhinha"
                                v-model="model.data.testeOrelhinha"
                                :min-date="others.moment(model.dataAtendimento).subtract(20, 'years').format('DD/MM/YYYY')"
                                :max-date="others.moment(model.dataAtendimento).format('DD/MM/YYYY')"
                            />
                        </rkm-col>
                        <rkm-col cols="3">
                            <rkm-form-select
                                label="Resultado - Teste da Orelhinha"
                                :options="form.exames.testeOrelhinha"
                                :disabled="!model.data.testeOrelhinha"
                                :validations="validations.resultado.testeOrelhinha"
                                v-model="model.resultado.testeOrelhinha"
                                show-default-option
                            />
                        </rkm-col>
                        <rkm-col cols="3">
                            <rkm-form-date-picker
                                label="US Transfontanela"
                                v-model="model.data.usTransfontanela"
                                :min-date="others.moment(model.dataAtendimento).subtract(20, 'years').format('DD/MM/YYYY')"
                                :max-date="others.moment(model.dataAtendimento).format('DD/MM/YYYY')"
                            />
                        </rkm-col>
                        <rkm-col>
                            <rkm-form-select
                                label="Resultado - US Transfontanela"
                                :options="form.exames.usTransfontanela"
                                :disabled="!model.data.usTransfontanela"
                                :validations="validations.resultado.usTransfontanela"
                                v-model="model.resultado.usTransfontanela"
                                show-default-option
                            />
                        </rkm-col>
                    </rkm-row>
                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-form-date-picker
                                label="Tomografia Computadorizada"
                                v-model="model.data.tomografiaComputadorizada"
                                :min-date="others.moment(model.dataAtendimento).subtract(20, 'years').format('DD/MM/YYYY')"
                                :max-date="others.moment(model.dataAtendimento).format('DD/MM/YYYY')"
                            />
                        </rkm-col>
                        <rkm-col cols="3">
                            <rkm-form-select
                                label="Resultado - Tomografia Computadorizada"
                                :options="form.exames.tomografiaComputadorizada"
                                :disabled="!model.data.tomografiaComputadorizada"
                                :validations="validations.resultado.tomografiaComputadorizada"
                                v-model="model.resultado.tomografiaComputadorizada"
                                show-default-option
                            />
                        </rkm-col>
                        <rkm-col cols="3">
                            <rkm-form-date-picker
                                label="Ressonância Magnética"
                                v-model="model.data.ressonanciaMagnetica"
                                :min-date="others.moment(model.dataAtendimento).subtract(20, 'years').format('DD/MM/YYYY')"
                                :max-date="others.moment(model.dataAtendimento).format('DD/MM/YYYY')"
                            />
                        </rkm-col>
                        <rkm-col>
                            <rkm-form-select
                                label="Resultado - Ressonância Magnética"
                                :disabled="!model.data.ressonanciaMagnetica"
                                :validations="validations.resultado.ressonanciaMagnetica"
                                :options="form.exames.ressonanciaMagnetica"
                                v-model="model.resultado.ressonanciaMagnetica"
                                show-default-option
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Vuex
import { mapActions } from 'vuex';

// Mixins
import { repository, formats, data, stringCase, object, error } from '@/mixins';

// Others
import moment from 'moment'

// Enums.
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'

export default ({
    props: {
        id: { type: Number, default: null }
    },
    data: () => ({
        form: {
            informacoesPaciente: [],
            turnos: [],
            exames: {
                testeOlhinho: [],
                fundoOlho: [],
                testeOrelhinha: [],
                usTransfontanela: [],
                tomografiaComputadorizada: [],
                ressonanciaMagnetica: []
            },
            cbos: [],
            unidades: [],
            infraestruturas: [],
            equipes: [],
            autocompleteFields: {
                profissional: [
                    { key: 'nome', searchable: true },
                ]
            }
        },
        model: {
            profissional: null,
            usuario: null,
            paciente: null,
            turno: null,
            cbo: null,
            unidade: null,
            infraestrutura: null,
            equipe: null,
            dataAtendimento: null,
            data: {
                testeOlhinho: null,
                fundoOlho: null,
                testeOrelhinha: null,
                usTransfontanela: null,
                tomografiaComputadorizada: null,
                ressonanciaMagnetica: null
            },
            resultado: {
                testeOlhinho: null,
                fundoOlho: null,
                testeOrelhinha: null,
                usTransfontanela: null,
                tomografiaComputadorizada: null,
                ressonanciaMagnetica: null
            },
        },
        others: {
            moment
        },
        unwatchers: {
            modelProfissional: null,
            modelUnidadeId: null,
        },
        enums: {
            permissao
        }
    }),
    watch: {
        'model.data.testeOlhinho'(dataTesteOlhinho) {
            if (dataTesteOlhinho === '') {
                this.model.resultado.testeOlhinho = null
            }
        },
        'model.data.fundoOlho'(dataExameFundoOlho) {
            if (dataExameFundoOlho === '') {
                this.model.resultado.fundoOlho = null
            }
        },
        'model.data.testeOrelhinha'(dataTesteOrelhinha) {
            if (dataTesteOrelhinha === '') {
                this.model.resultado.testeOrelhinha = null
            }
        },
        'model.data.usTransfontanela'(dataUsTransfontanela) {
            if (dataUsTransfontanela === '') {
                this.model.resultado.usTransfontanela = null
            }
        },
        'model.data.tomografiaComputadorizada'(dataTomografiaComputadorizada) {
            if (dataTomografiaComputadorizada === '') {
                this.model.resultado.tomografiaComputadorizada = null
            }
        },
        'model.data.ressonanciaMagnetica'(dataRessonanciaMagnetica) {
            if (dataRessonanciaMagnetica === '') {
                this.model.resultado.ressonanciaMagnetica = null
            }
        },
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            fichaComplementar: this.getConectaSusRepository('atencaoBasica.fichaComplementar')
        }

        this.load()
    },
    computed: {
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    atencao_basica_permissao: this.enums.permissao.FICHA_COMPLEMENTAR
                },
            }
        },
        validations() {

            return {
                profissional: {
                    required: true
                },
                unidade: {
                    required: true
                },
                infraestrutura: {
                    required: true
                },
                equipe: {
                    required: true
                },
                cbo: {
                    required: true
                },
                data: {
                    required: true
                },
                turno: {
                    required: true
                },
                resultado: {
                    testeOlhinho: {
                        required: true
                    },
                    fundoOlho: {
                        required: true
                    },
                    testeOrelhinha: {
                        required: true
                    },
                    usTransfontanela: {
                        required: true
                    },
                    tomografiaComputadorizada: {
                        required: true
                    },
                    ressonanciaMagnetica: {
                        required: true
                    }
                },
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {

                const url = this.$route.path.includes('create') ? 'create' : 'edit'

                const request = url == 'create'
                    ? this.repositories.fichaComplementar.create(this.id)
                    : this.repositories.fichaComplementar.edit(this.id)

                request
                    .then(({ data }) => {

                        this.form.informacoesPaciente = data.form.informacoesPaciente
                        this.form.turnos = data.form.turnos
                        this.form.dataAtual = data.form.dataAtual

                        this.form.informacoesPaciente.cns = this.form.informacoesPaciente.cns
                            ? this.formatCns(this.form.informacoesPaciente.cns)
                            : null

                        this.form.exames.testeOlhinho = data.form.exames.testeOlhinho
                        this.form.exames.fundoOlho = data.form.exames.fundoOlho
                        this.form.exames.testeOrelhinha = data.form.exames.testeOrelhinha
                        this.form.exames.usTransfontanela = data.form.exames.usTransfontanela
                        this.form.exames.tomografiaComputadorizada = data.form.exames.tomografiaComputadorizada
                        this.form.exames.ressonanciaMagnetica = data.form.exames.ressonanciaMagnetica

                        this.model.paciente = this.form.informacoesPaciente.id

                        if (data.model) {

                            this.model.profissional = data.model.profissional
                            this.model.unidade = data.model.unidade
                            this.model.infraestrutura = data.model.infraestrutura
                            this.model.cbo = data.model.cbo
                            this.model.equipe = data.model.equipe

                            this.model.turno = data.model.turno
                            this.model.dataAtendimento = this.getFormatedDate(data.model.dataAtendimento, 'YYYY-MM-DD')

                            this.model.data.testeOlhinho = data.model.datas.testeOlhinho
                            this.model.resultado.testeOlhinho = data.model.resultados.testeOlhinho

                            this.model.data.fundoOlho = data.model.datas.fundoOlho
                            this.model.resultado.fundoOlho = data.model.resultados.fundoOlho

                            this.model.data.testeOrelhinha = data.model.datas.testeOrelhinha
                            this.model.resultado.testeOrelhinha = data.model.resultados.testeOrelhinha

                            this.model.data.usTransfontanela = data.model.datas.usTransfontanela
                            this.model.resultado.usTransfontanela = data.model.resultados.usTransfontanela

                            this.model.data.tomografiaComputadorizada = data.model.datas.tomografiaComputadorizada
                            this.model.resultado.tomografiaComputadorizada = data.model.resultados.tomografiaComputadorizada

                            this.model.data.ressonanciaMagnetica = data.model.datas.ressonanciaMagnetica
                            this.model.resultado.ressonanciaMagnetica = data.model.resultados.ressonanciaMagnetica
                        } else {

                            this.model.dataAtendimento = this.getFormatedDate(data.form.dataAtual, 'YYYY-MM-DD')
                        }

                        if (this.model.profissional && this.model.profissional.id) {

                            this.getUnidades()

                            if (this.model.unidade) {

                                this.getInfraestruturas()
                                this.getEquipes()
                                this.getOcupacoes()
                            }
                        }

                        this.$nextTick(function () {this.addWatchers()})
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        addWatchers() {

            this.addModelUnidadeIdWatcher()
            this.addModelProfissionalWatcher()
            this.addModelInfraestruturaIdWatcher()
        },
        addModelProfissionalWatcher() {

            this.unwatchers.modelProfissional = this.$watch('model.profissional', function (usuario) {

                if (usuario) {

                    this.getUnidades()
                }

                this.setCadastro('usuario')
            })
        },
        addModelUnidadeIdWatcher() {

            this.unwatchers.modelUnidadeId = this.$watch('model.unidade', function (unidadeId) {

                if (unidadeId) {

                    this.getInfraestruturas()
                }

                this.setCadastro('unidade')
            })
        },
        addModelInfraestruturaIdWatcher() {

            this.unwatchers.modelInfraestruturaId = this.$watch('model.infraestrutura', function (infraestruturaId) {

                if (infraestruturaId) {

                    this.getEquipes()
                    this.getOcupacoes()
                }

                this.setCadastro('infraestrutura')
            })
        },
        prepareData() {
            return this.camelObjectKeysToSnakeRecursive(this.clone(this.model))
        },
        save() {
            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const url = this.$route.path.includes('create') ? 'create' : 'edit'

                    this.model.usuario = this.model.profissional.id

                    delete this.model.profissional

                    const request = url == 'create'
                        ? this.repositories.fichaComplementar.store(this.prepareData())
                        : this.repositories.fichaComplementar.update(this.id, this.prepareData())

                    request
                        .then(({ data }) => {
                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        getUnidades() {

            this.setLoading()

            this.repositories.fichaComplementar.getUnidades({usuario_id: this.model.profissional.id})
                .then(({ data }) => {

                    this.form.unidades = data

                    if (data.length === 1){

                        this.model.unidade = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturas() {

            this.setLoading()

            this.repositories.fichaComplementar.getInfraestruturas({
                usuario_id: this.model.profissional.id,
                unidade_id: this.model.unidade
            })
                .then(({ data }) => {

                    this.form.infraestruturas = data

                    if (data.length === 1) {

                        this.model.infraestrutura = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {

            this.setLoading()

            this.repositories.fichaComplementar.getEquipes({
                usuario_id: this.model.profissional.id,
                infraestrutura_id: this.model.infraestrutura
            })
                .then(({ data }) => {

                    this.form.equipes = data

                    if (data.length === 1){

                        this.model.equipe = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoes() {

            this.setLoading()

            this.repositories.fichaComplementar.getOcupacoes({
                usuario_id: this.model.profissional.id,
                infraestrutura_id: this.model.infraestrutura
            })
                .then(({ data }) => {

                    this.form.cbos = data

                    if (data.length === 1){

                        this.model.cbo = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setCadastro(field) {

            if (field === 'usuario'){

                this.model.unidade = null
                this.model.infraestrutura = null
                this.model.equipe = null
                this.model.cbo = null
            } else if (field === 'unidade'){

                this.model.infraestrutura = null
                this.model.equipe = null
                this.model.cbo = null
            } else {

                this.model.equipe = null
                this.model.cbo = null
            }
        }
    },
    mixins: [repository, formats, data, stringCase, object, error],
})
</script>